import React from 'react';
import styled from 'styled-components';
import { IKeyOfferingItem, KeyOfferingItem } from './KeyOfferingItem';
import { SectionHeader } from '../Section';
import Spacer from 'src/components/Layout/Spacer';

const ReportingSectionContainer = styled.div`
  margin: 1rem;
`;
const ReportingContainer = styled.div`
  display: flex;
  justify-content: space-around;
`;

const Header = styled.h2`
  line-height: 2.5;
  text-align: center;
`;

interface IKeyOfferings {
  header: string;
  items: IKeyOfferingItem[];
}

const KeyOfferings: React.FC<IKeyOfferings> = ({ header, items }) => {
  return (
    <ReportingSectionContainer>
      <Header data-testid="ReportingSectionContainerHeader">{header}</Header>
      <Spacer height="2rem" />
      <ReportingContainer>
        {items &&
          items.map((item, index) => {
            if (item.hidden && item.hidden === true) {
              return;
            }
            return (
              <KeyOfferingItem
                key={index}
                iconName={item.iconName}
                header={item.header}
                description={item.description}
                primaryButtonLabel={item.primaryButtonLabel}
                primaryButtonAction={item.primaryButtonAction}
                secondaryButtonAction={item.secondaryButtonAction}
                secondaryButtonlabel={item.secondaryButtonlabel}
              ></KeyOfferingItem>
            );
          })}
      </ReportingContainer>
    </ReportingSectionContainer>
  );
};

export { KeyOfferings };
